/**
 * Shared conversation ID utilities.
 * Used by both frontend and backend to ensure consistency.
 */

/**
 * Build a conversation ID from parts.
 * DMs get the 3-part format (chatId:platform:userPhone),
 * groups get the 2-part format (chatId:platform).
 */
export function buildConversationId(
  chatId: string,
  platform: string,
  chatType?: string | null,
  userPhone?: string | null,
): string {
  if (chatType === "dm" && userPhone) {
    return `${chatId}:${platform}:${userPhone}`;
  }
  return `${chatId}:${platform}`;
}

export function parseConversationId(conversationId: string): {
  chatId: string;
  platform: string;
  userPhone?: string;
} {
  if (!conversationId) return { chatId: "", platform: "" };
  const [chatId = "", platform = "", userPhone] = conversationId.split(":");
  return userPhone ? { chatId, platform, userPhone } : { chatId, platform };
}
